<template>
    <p-card class="mb-2 py-2" no-body>
        <b-row class="justify-content-center">
            <b-col class="d-flex flex-wrap gap-3 justify-content-center">
                <p-select label="Saved Template"
                          class="flex-grow-1"
                          style="min-width: 300px"
                          :options="userReportTemplateOptions"
                          :model-value="selectedUserReportTemplateId"
                          @update:model-value="$emit('update:selected-user-report-template-id', $event)"
                          no-selection-message="None"
                          @selectedObject="$emit('selectedObject', $event)" />
                <div>
                    <label class="form-label invisible d-block">&nbsp;</label>
                    <p-button
                        variant="outline-primary"
                        title="Copy the selected template's name"
                        :disabled="!selectedUserReportTemplate"
                        @click="$emit('update:template-name', selectedUserReportTemplate.templateName)"
                        ><b-icon-chevron-right></b-icon-chevron-right
                    ></p-button>
                </div>
                <div>
                    <p-input label="Template Name"
                            class="flex-grow-1"
                            style="min-width: 300px"
                            :model-value="templateName"
                            @update:model-value="$emit('update:template-name', $event)"
                            rules="max:50" />
                    <div>Enter a name to save these settings</div>
                </div>
            </b-col>
        </b-row>
    </p-card>
</template>

<script>
export default {
    props: {
        userReportTemplateOptions: {
            type: Array,
            required: true
        },
        selectedUserReportTemplateId: {
            type: [Number, String],
            default: null
        },
        selectedUserReportTemplate: {
            type: Object,
            default: null
        },
        templateName: {
            type: String,
            default: null
        }
    }
};
</script>
